import { ExcessMoneySettlementReducerDispatch, ExcessMoneySettlementRedux, ExcessMoneySettlementReduxState, ExcessMoneySettlementTypes, ExcessMoneySettlementListUiState } from "./types"

const FETCH_EXCESS_MONEY_SETTLEMENT_LIST_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
}

const ExcessMoneySettlementListReducer = (state: ExcessMoneySettlementReduxState = FETCH_EXCESS_MONEY_SETTLEMENT_LIST_INIT_STATE, action: ExcessMoneySettlementReducerDispatch) => {
    switch (action.type) {
        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS: {
            return {
                ...state,
                loading: true
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ExcessMoneySettlementTypes.RESET: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}

const FETCH_EXCESS_MONEY_SETTLEMENT_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const ExcessMoneySettlementReducer = (state: ExcessMoneySettlementRedux = FETCH_EXCESS_MONEY_SETTLEMENT_INIT_STATE, action: ExcessMoneySettlementReducerDispatch) => {
    switch (action.type) {
        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT: {
            return {
                ...state,
                loading: true
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }

        case ExcessMoneySettlementTypes.RESET: {     
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}


const EXCESS_MONEY_SETTLEMENT_LIST_UI_INIT_STATE: ExcessMoneySettlementListUiState = {
  currentPage: 1,
  searchFilter: {},
  sort: { field: "updatedOn", order: false },
  isFilterApplied: false
};

/** List UI state — intentionally ignores entity RESET so filters survive route changes */
const ExcessMoneySettlementListUiReducer = (
  state: ExcessMoneySettlementListUiState = EXCESS_MONEY_SETTLEMENT_LIST_UI_INIT_STATE,
  action: { type: string; payload?: Partial<ExcessMoneySettlementListUiState> }
) => {
  switch (action.type) {
    case ExcessMoneySettlementTypes.SET_EXCESS_MONEY_SETTLEMENT_LIST_UI:
      return {
        ...state,
        ...action.payload
      };
    case ExcessMoneySettlementTypes.RESET_EXCESS_MONEY_SETTLEMENT_LIST_UI:
      return { ...EXCESS_MONEY_SETTLEMENT_LIST_UI_INIT_STATE };
    default:
      return state;
  }
};

export { ExcessMoneySettlementListUiReducer, ExcessMoneySettlementListReducer, ExcessMoneySettlementReducer };